export const isActionDisabled = (record: any, type: string, actionCondition: any) => {
  if (!actionCondition[type] || !actionCondition[type].length) {
    return false
  }
  for (let condition of actionCondition[type]) {
    let pass = true
    for (let key in condition) {
      const val = condition[key]
      if (record[key] !== val) {
        pass = false
      }
    }
    if (pass) {
      return false
    }
  }

  return true
}
